import FocusLock from './Combination';
export * from './UI';
export default FocusLock;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-focus-lock/dist/es2015/index.js
// module id = 1180
// module chunks = 0